<template>
    <div>
        <LoadingOverlay :loading="loading" />
        <div class="weeklyRankRewards-tableSec">
            <div class="weeklyRankRewards-HD">Weekly Ranking Rewards</div>
            <div class="weeklyRankRewards-tableWrap">
                <table>
                    <tbody>
                        <tr v-for="reward in WeeklyRankRewardsCharmData" :key="reward.id">
                            <td>Top {{ reward.rank }}</td>
                            <td><span><img :src='beansIcon' class="beansIcon" alt="" /></span> {{ reward.reward_coin }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="rankingRewards-ruleCont">
            <ul>
                <li>Activity time:  Weekly Charm will give rewards and update new rank on 00:00 GMT +5:30 time every Sunday.</li>
                <li>It is ranked by the beans you had received by users, including call income, gift income.</li>
                <li><b style="color: #131b23;">Call beans and gifts sent during calls are not counted in charm rewards.</b></li>
                <li>If you have any questions, please contact the official by your agency.</li>                
            </ul>
        </div>
    </div>

</template>
<script>
import axios from 'axios';
import beansIcon from '../../assets/images/beansIcon.png'
import LoadingOverlay from '../LoadingOverlay.vue'
export default {
    name: 'weeklyRankRewardsCharm',
    components: {
        LoadingOverlay
    },
    data() {
        return {
            WeeklyRankRewardsCharmData: [],
            beansIcon: beansIcon,
            loading: false,
        }
    },
    mounted() {
        this.fetchWeeklyRankRewardsCharmData();
    },
    methods: {
        fetchWeeklyRankRewardsCharmData() {
            this.loading= true;
            const tokenParam = this.$route.params.token;
            const token = tokenParam.split('=')[0];
            const apiUrl = `api/top-charm-weekly?type=this_week`;
            axios.get(apiUrl, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            })
                .then(response => {
                    this.WeeklyRankRewardsCharmData = response.data.result.rewards;
                })

                .catch(error => {
                    console.error("Error Featching Weekly Data", error)
                })
                .finally(() => {
                    this.loading = false;
                })
        },
    },
}
</script>